<template>
    <div class="div-bottom">
      <div class="div-img-top body-width divcss5 ">
        <div class="font_zh ">
          {{$t("product.productcenter")}}
        </div>
        <div class="font_en font_en_top">
          PRODUCT CENTER
        </div>
      </div>
      <div class="row product_content">
        <div class="product_body">
          <div  align="left"
                :class="product.hhmnq?'product_content_img':'product_content_img1'"
               @click="setroters('/producthhmnq/productcp')"
               @mouseenter="handleMouseEnterImg('hhmnq')"
               @mouseleave="handleMouseLeaveImg('hhmnq')">
            <img  src="../../../assets/images/productcenter/8.png">
          </div>
          <div class="product_content_icon1">
            <img src="../../../assets/images/productcenter/6.png">
          </div>
          <div :class="font.hhmnq?'product_content_title1_blue':'product_content_title1'"
               @mouseenter="handleMouseEnterFont('hhmnq')"
               @mouseleave="handleMouseLeaveFont('hhmnq')">
            <a  @click="setroters('/producthhmnq/productcp')">{{$t("product.product1")}}</a>
          </div>
          <div class="product_content_detail1 news-Regular-14b6">
            <!-- 通过挪威船级社、中国船级社认证<br>
            符合STCW公约、《船员培训模拟器<br>
            性能标准》<br>
            开放接口、满足船员培训和航海科<br>
            研需求 -->
          </div>
        </div>
        <div>
          <div :class="font.hhxnsxx?'product_content_title2_blue':'product_content_title2'"
               @mouseenter="handleMouseEnterFont('hhxnsxx')"
               @mouseleave="handleMouseLeaveFont('hhxnsxx')">
            <a @click="setroters('/producthhxnsx/hhxnxl')">{{$t("product.product8")}}</a>
          </div>
          <div class="product_content_detail2 news-Regular-14b6">
            <!-- 通过船级社认证<br>更专业、更智能 -->
           <br>
           <br>
          </div>
          <div class="product_content_icon2" >
            <img src="../../../assets/images/productcenter/7.png">
          </div>
          <div :class="product.hhxnsxx?'product_content_img':'product_content_img1'"
               @click="setroters('/producthhxnsx/hhxnxl')"
               @mouseenter="handleMouseEnterImg('hhxnsxx')"
               @mouseleave="handleMouseLeaveImg('hhxnsxx')">
            <img src="../../../assets/images/productcenter/9.png">
          </div>
        </div>
        <div>
          <div :class="product.znhy?'product_content_img':'product_content_img1'"
               @click="setroters('/productznhy/zncbajyckzz')"
               @mouseenter="handleMouseEnterImg('znhy')"
               @mouseleave="handleMouseLeaveImg('znhy')">
            <img src="../../../assets/images/productcenter/10.png">
          </div>
          <div class="product_content_icon3">
            <img src="../../../assets/images/productcenter/6.png">
          </div>
          <div :class="font.znhy?'product_content_title3_blue':'product_content_title3'"
               @mouseenter="handleMouseEnterFont('znhy')"
               @mouseleave="handleMouseLeaveFont('znhy')">
            <a @click="setroters('/productznhy/zncbajyckzz')">{{$t("product.product9")}}</a>
          </div>
          <div class="product_content_detail3 news-Regular-14b6">
            <!-- 应急方案预演<br>
            海陆空协同演练<br>
            海上事故重演<br> -->
          </div>
        </div>
        <div >
          <div :class="font.hhwhyx?'product_content_title4_blue':'product_content_title4'"
               @mouseenter="handleMouseEnterFont('hhwhyx')"
               @mouseleave="handleMouseLeaveFont('hhwhyx')">
            <a @click="setroters('/producthhwhyx/hhwhyxgkj')">
            <div>{{ $t("product.product11") }}</div>
            <div>{{ $t("product.product12") }}</div>
            </a>
          </div>
          <div class="news-Regular-14b6">
            <!-- 专业的海事背景<br>
            真实的VR体验<br> -->
            <br>
            <br>
          </div>
          <div class="product_content_icon4">
            <img src="../../../assets/images/productcenter/7.png">
          </div>
          <div :class="product.hhwhyx?'product_content_img':'product_content_img1'"
               @click="setroters('/producthhwhyx/hhwhyxgkj')"
               @mouseenter="handleMouseEnterImg('hhwhyx')"
               @mouseleave="handleMouseLeaveImg('hhwhyx')">
            <img src="../../../assets/images/productcenter/11.png">
          </div>
        </div>
        <!-- <div>
          <div :class="product.hlw?'product_content_img':'product_content_img1'"
               @click="setroters('/producthlwhhjy')"
               @mouseenter="handleMouseEnterImg('hlw')"
               @mouseleave="handleMouseLeaveImg('hlw')">
            <img src="../../../assets/images/productcenter/5.png">
          </div>
          <div class="product_content_icon5">
            <img src="../../../assets/images/productcenter/6.png">
          </div>
          <div :class="font.hlw?'product_content_title5_blue':'product_content_title5'"
               @mouseenter="handleMouseEnterFont('hlw')"
               @mouseleave="handleMouseLeaveFont('hlw')">
            <a @click="setroters('/producthlwhhjy')">{{$t("product.product5")}}</a>
          </div>
          <div class="product_content_detail5 news-Regular-14b6">
            丰富的航海教育资源<br>
            跨平台的可视化交互学习环境
          </div>
        </div> -->
      </div>
    </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  export default {
    name: "productpartcontent",
    data() {
      return {
        header:{
          showindex:false,
          showabout:false,
          showproduct:true,
          shownews:false,
          showjoin:false,
          showpartner:false,
          showcontact:false,
          showlanguage:false,
        },
        product:{
          hhmnq:false,
          hhxnsxx:false,
          znhy:false,
          hhwhyx:false,
          hlw:false,
        },
        font:{
          hhmnq:false,
          hhxnsxx:false,
          znhy:false,
          hhwhyx:false,
          hlw:false,
        }
      }
    },
    methods: {
      ...mapMutations(['setHeaderTitle']),
      setroters(src) {
        this.switchStyle()
        this.$router.push(src)
      },
      switchStyle(){
        this.setHeaderTitle(this.header)
      },
      handleMouseEnterImg(val){
        if('hhmnq' === val) {
          this.product.hhmnq = true
        }
        if('hhxnsxx' === val) {
          this.product.hhxnsxx = true
        }
        if('znhy' === val) {
          this.product.znhy = true
        }
        if('hhwhyx' === val) {
          this.product.hhwhyx = true
        }
        if('hlw' === val) {
          this.product.hlw = true
        }
      },
      handleMouseLeaveImg(val) {
        if('hhmnq' === val) {
          this.product.hhmnq = false
        }
        if('hhxnsxx' === val) {
          this.product.hhxnsxx = false
        }
        if('znhy' === val) {
          this.product.znhy = false
        }
        if('hhwhyx' === val) {
          this.product.hhwhyx = false
        }
        if('hlw' === val) {
          this.product.hlw = false
        }
      },
      handleMouseEnterFont(val){
        if('hhmnq' === val) {
          this.font.hhmnq = true
        }
        if('hhxnsxx' === val) {
          this.font.hhxnsxx = true
        }
        if('znhy' === val) {
          this.font.znhy = true
        }
        if('hhwhyx' === val) {
          this.font.hhwhyx = true
        }
        if('hlw' === val) {
          this.font.hlw = true
        }
      },
      handleMouseLeaveFont(val) {
        if('hhmnq' === val) {
          this.font.hhmnq = false
        }
        if('hhxnsxx' === val) {
          this.font.hhxnsxx = false
        }
        if('znhy' === val) {
          this.font.znhy = false
        }
        if('hhwhyx' === val) {
          this.font.hhwhyx = false
        }
        if('hlw' === val) {
          this.font.hlw = false
        }
      }
    }
  }

</script>

<style scoped>
  /*字体*/
  .font_zh{
    font-size: 24px;
    color: #0d3e88;
  }
  .font_en{
    font-size: 16px;
    color: #2e79be;
  }
  .product_content{
    width: 1200px;
    height: 450px;
    padding-top: 40px;
    margin-left: 5px;
  }
  .product_content_icon1{
    padding-top: 10px;
  }
  .product_content_title1{
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
    font-size: 18px;
    color: #333333;
  }
  .product_content_title1_blue{
    text-align: center;
    padding-top: 10px;
    padding-bottom: 20px;
    font-size: 18px;
    color: #2E79BE;
  }
  .product_content_detail1{
    text-align: left;
  }

  .product_content_title2_blue{
    padding-top: 96px;
    padding-bottom: 20px;
    font-size: 18px;
    color: #2e79be;
  }
  .product_content_title2{
    padding-top: 96px;
    padding-bottom: 20px;
    font-size: 18px;
    color: #333333;
  }

  .product_content_detail2{
    padding-bottom: 10px;
  }
  .product_content_icon2{
    padding-bottom: 10px;
  }
  .product_content_title4{
    padding-top: 96px;
    font-size: 18px;
    padding-bottom: 20px;
    color: #333333;
  }
  .product_content_title4_blue{
    padding-top: 96px;
    font-size: 18px;
    padding-bottom: 20px;
    color: #2e79be;
  }
/*  .product_content_detail4{
    font-size: 14px;
    color: #B6B6B6;
  }*/
  .product_content_icon3{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .product_content_title3{
    padding-bottom: 20px;
    font-size: 18px;
    color: #333333;
  }
  .product_content_title3_blue{
    padding-bottom: 20px;
    font-size: 18px;
    color: #2e79be;
  }
  .product_content_detail3{
    text-align: left;
    padding-left: 65px;
  }

  .product_content_icon5{
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .product_content_title5_blue{
    font-size: 18px;
    color: #2e79be;
  }
  .product_content_title5{
    font-size: 18px;
    color: #333333;
  }
  .product_content_detail5{
    text-align: left;
    padding-left: 40px;
  }
  .product_content_img{
    cursor: pointer;
    color: #2e79be;
    opacity: 0.5;
  }
.div-bottom{
  margin-bottom: 20px;
  padding-top: 50px;
    padding-bottom: 20px;
    text-align: center;
    }
  
  
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/productpartcontent.vue